
import React, { useState } from "react";
import Main2 from "./Main2";
import WaitlistForm from "./emailForm";

const ComponentSlider = () => {
  const [showForm, setShowForm] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);

  return (
    <>
      <Main2
        isDownloaded={isDownloaded}
        setIsDownloaded={setIsDownloaded}
        showForm={showForm}
        setShowForm={setShowForm}
      />

      {showForm && (
        <WaitlistForm onClose={() => setShowForm(false)} />
      )}
    </>
  );
};

export default ComponentSlider;